import moment from 'moment';

export default function formatDate(date) {
  if (!date || !moment(date).isValid()) {
    return '';
  }

  return moment(date).format('YYYY-MM-DD');
}
